<template>
  <div id="footer" class="container-fluid">
    <div class="container">
      <div class="row">
        <div class="col-md-10 col-sm-8 col-xs-12">
          <ul class="content">
            <li class="item">
              <dl>
                <dt>产品中心</dt>
                <!-- <dd><a style="color: #e5e5e5;"><router-link to="/newsinformation">屏幕泄密溯源取证系统</router-link></a></dd> -->
                <dd style="color: #e5e5e5">屏幕泄密溯源取证系统</dd>
                <dd style="color: #e5e5e5">文档打印溯源取证系统</dd>
                <!-- <dd><a style="color: #e5e5e5;">文档打印溯源取证系统</a></dd> -->
                <dd style="color: #e5e5e5">水印加密文件分发系统</dd>
              </dl>
            </li>
            <li class="item">
              <dl>
                <dt>关于我们</dt>
                <dd style="color: #e5e5e5">公司介绍</dd>
                <dd style="color: #e5e5e5">荣誉资质</dd>
                <dd style="color: #e5e5e5">技术优势</dd>
              </dl>
            </li>
            <li class="item1">
              <dl>
                <dt>联系我们</dt>
                <dd style="color: #e5e5e5">业务电话：13647217123</dd>
                <dd style="color: #e5e5e5">邮箱：yskj_hz8034@163.com</dd>
                <dd style="color: #e5e5e5">
                  地址：浙江省杭州市萧山区经济技术开发区明星路371号1幢803-4室
                </dd>
              </dl>
            </li>
            <!-- <li class="item">
                        <dl>
                            <dt>联系我们</dt>
                            <dd>服务电话：13647217123</dd>
                            <dd>简历投递：yskj_hz8034@163.com</dd>
                        </dl>
                    </li> -->
          </ul>
        </div>
        <!-- <div class="qrcode col-md-2 col-sm-4 col-xs-12">
          <img class="img-responsive" src="@/assets/img/qrcode.png" alt="" />
          <p>关注我们</p>
        </div> -->
      </div>
    </div>
    <div class="copyright">
      <span
        >Copyright © 2019 元神科技(杭州)有限公司
      </span>
      <!-- <span
        >Copyright © 2019 元神科技(杭州)有限公司 ICP 备案号：<a
          href="https://beian.miit.gov.cn"
          target="_blank"
          style="color: #999"
          >皖ICP备15000460号-2</a
        >
      </span> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
};
</script>
<style scoped>
/* --------------- S 底部导航 --------------- */
#footer {
  padding-top: 42px;
  background: #3b3b3b;
}

#footer ul.content {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  padding-left: 0;
}

#footer ul.content > li.item {
  width: 25%;
  padding-bottom: 28px;
}

#footer ul.content > li dt {
  color: #fff;
  margin-bottom: 18px;
  font-weight: normal;
}

#footer ul.content > li a,
#footer ul.content > li dd {
  color: #999;
  line-height: 1.8em;
}

#footer ul.content > li a:hover {
  color: #187fc4;
}

#footer ul.content > li.item1 {
  width: 50%;
  padding-bottom: 28px;
}
/* #footer ul.content>li.item1 dt {
  color: #fff;
  margin-bottom: 18px;
  font-weight: normal;
}

#footer ul.content>li.item1 a,#footer ul.content>li.item1 dd {
  color: #999;
  line-height: 1.8em;
}

#footer ul.content>li.item1 a:hover {
  color: #187fc4;
} */

#footer div.qrcode {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 0 10px 0;
  /* border-left: solid 1px #555; */
}

#footer div.qrcode img {
  width: 80px;
}

#footer div.qrcode p {
  text-align: center;
  color: #999;
  margin-top: 10px;
}

#footer div.copyright {
  text-align: center;
  font-size: 12px;
  color: #999;
  border-top: solid 1px #555;
  padding: 10px 15px;
}

#footer div.copyright span {
  color: #999;
}

@media only screen and (max-width: 992px) {
  #footer ul.content > li.item {
    width: 50%;
  }
  #footer ul.content > li.item1 {
    width: 100%;
  }
}

@media only screen and (max-width: 768px) {
  #footer ul.content > li.item {
    width: 100%;
  }
  #footer ul.content > li.item1 {
    width: 100%;
  }
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue